<template>
    <div>
        <div class="inner mb-4 p-4" v-if="partners.providers">
            <b-row>
                <b-col md="4">
                    <h3 class="display-3 position-sticky mb-4">{{ $t('Compare other deals') }}</h3>
                </b-col>
                <b-col md="8">
                    <template v-for="offer in partnersLimited">
                        <b-card bg-variant="light" border-variant="light" v-if="!partners.providers[offer.providerIndex].isDirect" :key="offer.bookUri" class="mb-2">
                            <b-row align-v="center">
                                <b-col md="5">
                                    <h3>{{ partners.providers[offer.providerIndex].name }}</h3>
                                    <!-- <img :src="partners.providers[offer.providerIndex].logo" :alt="partners.providers[offer.providerIndex].name" class="img-fluid"/>-->
                                    <!-- <pre>{{ offer }}</pre> -->
                                    <h4 class="display-5 mb-0">{{ offer.roomName }}</h4>
                                    <div v-if="offer.hasFreeCancellation" class="highlight">
                                        {{ $t('Fully refundable') }}
                                    </div>
                                    <div v-if="offer.canPayLater" class="highlight">
                                        {{ $t('Reserve now, pay later') }}
                                    </div>
                                </b-col>
                                <b-col md="4" class="text-md-right">
                                    <PartnerPrice :offer="offer" :search="search" />
                                </b-col>
                                <b-col md="3" class="text-md-right">
                                    <b-button variant="primary" :href="offer.bookUri" target="_blank">
                                        {{ $t('Visit deal') }} >
                                    </b-button>
                                </b-col>
                            </b-row>
                        </b-card>
                    </template>
                    <b-button v-if="this.partners.results > this.showLimit" variant="outline-secondary" @click="increaseSlice" block>
                        {{ $t('Show more deals') }}
                    </b-button>
                </b-col>
            </b-row>
        </div>
        <!--
        <div v-else class="inner mb-5">
            <b-row>
                <b-col md="8">
                    <div class="p-5">
                        <content-placeholders :rounded="true">
                            <content-placeholders-heading/>
                            <content-placeholders-text :lines="4"/>
                        </content-placeholders>
                        <content-placeholders :rounded="true">
                            <content-placeholders-heading/>
                            <content-placeholders-text :lines="4"/>
                        </content-placeholders>
                    </div>
                </b-col>
                <b-col md="4">
                    <div class="p-5">
                        <content-placeholders :rounded="true">
                            <content-placeholders-img/>
                            <content-placeholders-text :lines="1"/>
                        </content-placeholders>
                        <content-placeholders :rounded="true">
                            <content-placeholders-heading/>
                            <content-placeholders-text :lines="5"/>
                        </content-placeholders>
                    </div>
                </b-col>
            </b-row>
        </div>
        -->
    </div>
</template>

<script>
    import PartnerPrice from '@/components/ui/PartnerPrice'

    export default {
        name: 'PartnerDeals',
        components: {
            PartnerPrice,
        },
        data () {
            return {
                showLimit: 4,
            }
        },
        computed: {
            partnersLimited: function() {
                if (this.partners.results) {
                    return this.partners.results.slice(0, this.showLimit)
                }

                return [];
            }
        },
        props: {
            partners: {
                type: Object,
                required: true
            },
            search: {
                type: Object,
                required: true
            },
        },
        methods: {
            increaseSlice: function() {
                this.showLimit = this.showLimit + 5;
            }
        }
    }
</script>

<style scoped>
    .highlight{
        color:#066706;
    }
    .inner{
        background-color:#fff;
    }
    .display-5{
        font-size:0.8rem;
    }
    .position-sticky{
        top:0;
    }
    h3.position-sticky{
        top:55px;
    }
</style>